/**
 * Below md, an invisible halo around a small text link widens its tap area to
 * about thumb size without moving the text.
 */
export const PHONE_TAP_HALO = 'max-md:relative max-md:after:absolute max-md:after:-inset-2.5'
